module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "d-flex flex-column overflow-hidden",
    class: [{
      'collapsed': !_vm.isHoveringMenu
    }, _vm.environment],
    on: {
      "mouseenter": _vm.mouseenter,
      "mouseleave": _vm.mouseleave
    }
  }, [_c('nav', {
    staticClass: "flexGrow1",
    attrs: {
      "role": "navigation"
    }
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('div', {
    staticClass: "logoCanvas"
  }, [_c('img', {
    staticClass: "logoBig",
    attrs: {
      "src": require("../../assets/images/logo.svg"),
      "alt": "Pluralo"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "logoSmall",
    attrs: {
      "src": "/static/images/common/logo_small_red_white.svg",
      "alt": "Pluralo"
    }
  })]), _vm._v(" "), _c('ul', _vm._l((_vm.linksNew), function(link) {
    return (_vm.showThisLink(link)) ? _c('li', {
      staticClass: "position-relative"
    }, [_c('router-link', {
      attrs: {
        "exact": "",
        "active-class": "active",
        "to": {
          name: link.linkTo
        }
      }
    }, [_c('span', {
      staticClass: "selection"
    }), _vm._v(" "), _c('span', {
      staticClass: "fs-larger position-relative"
    }, [_c('i', {
      class: link.icon
    }), _vm._v(" "), (_vm.showNewLabel(link)) ? _c('span', {
      staticClass: "newItemLabel fs-smallest bg-color-1"
    }, [_vm._v("New")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(link.label))])])], 1) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "bottomInfoBig darker p-2"
  }, [_c('span', {
    staticClass: "pointer",
    on: {
      "click": _vm.reloadApp
    }
  }, [_c('i', {
    staticClass: "ico ico-reshedule fs-normal"
  }), _vm._v(" " + _vm._s(_vm.version) + " Beta - ")]), _vm._v(" "), _c('span', {
    staticClass: "fs-smaller darker",
    on: {
      "click": _vm.testPerformance
    }
  }, [_vm._v(_vm._s(_vm.getUserAccessType.label))])]), _vm._v(" "), _c('div', {
    staticClass: "bottomInfoSmall darker p-2 text-center"
  }, [_c('span', [_vm._v(_vm._s(_vm.version))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1531711e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1531711e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Sidebar.vue
// module id = 1373
// module chunks = 0